import { Link } from "react-router-dom/cjs/react-router-dom";

export const ReportSummaryCard = ({ reportSummary, organisationId }) => {
    const reportDetailsUrl = `/organisation/${organisationId}/reports/${reportSummary.urlSlug}`

    return (
        <div className="shadow-sm report-summary-card border rounded rounded-3 d-flex p-3 position-relative">
            <div className="px-1 d-flex flex-column py-1 justify-content-between">
                <div className="flex-grow-1">
                    <p className="font-weight-bold m-0 mb-1 fs-1">{ reportSummary.title }</p>
                    <p className="m-0 fs--1">{ reportSummary.summaryDescription }</p>
                </div>
                <Link to={ reportDetailsUrl } className="btn btn-secondary nowrap align-self-start mt-3 fs--1">
                    View Report<i class="fas fa-chevron-right ml-2"></i>
                </Link>
            </div>
            <i className={ `${ reportSummary.iconClass } text-${reportSummary.iconBackground} report-summary-icon` }></i>
        </div>
    )
}